import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import CorporationSettings from '@/views/corporation-settings/CorporationSettings';
import PlannedServicesIndex from '@/views/plannedService/PlannedServiceIndex';
import PlannedServiceDetails from '@/views/plannedService/PlannedServiceDetails';
import FrontpageMain from '@/views/frontpage/FrontpageMain';
import Frontpage from '@/views/frontpage/Frontpage';
import DefectReportIndex from '@/views/defectreport/DefectReportIndex';
import DefectReportDetails from '@/views/defectreport/DefectReportDetails';
import ServiceIndex from '@/views/service/ServiceIndex';
import ServiceDetails from '@/views/service/ServiceDetails';
import CorporationIndex from '@/views/corporations/CorporationIndex';
import CorporationDetails from '@/views/corporations/CorporationDetails';
import ServiceRequestIndex from '@/views/servicerequest/ServiceRequestIndex';
import ServiceRequestDetails from '@/views/servicerequest/ServiceRequestDetails';
import SiteNotificationIndex from '@/views/sitenotification/SiteNotificationIndex';
import SiteNotificationDetails from '@/views/sitenotification/SiteNotificationDetails';
import PartOrderIndex from '@/views/partorder/PartOrderIndex';
import PartOrderDetails from '@/views/partorder/PartOrderDetails';
import EntityMain from '@/components/entity-crud/EntityMain';

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Login,
  },

  {
    path: '/status',
    component: FrontpageMain,
    children: [
      {
        path: '',
        name: 'Frontpage',
        component: Frontpage,
      },
    ],
  },

  {
    path: '/corporations',
    component: EntityMain,
    children: [
      {
        path: '',
        name: 'Corporations',
        component: CorporationIndex,
      },
      {
        path: ':id',
        name: 'Corporation',
        component: CorporationDetails,
      },
    ],
  },
  {
    path: '/plannedservices',
    component: EntityMain,
    children: [
      {
        path: '',
        name: 'PlannedServices',
        component: PlannedServicesIndex,
      },
      {
        path: ':id',
        name: 'PlannedService',
        component: PlannedServiceDetails,
      },
    ],
  },
  {
    path: '/sitenotifications',
    component: EntityMain,
    children: [
      {
        path: '',
        name: 'SiteNotifications',
        component: SiteNotificationIndex,
      },
      {
        path: ':id',
        name: 'Notification',
        component: SiteNotificationDetails,
      },
    ],
  },
  {
    path: '/servicerequests',
    component: EntityMain,

    children: [
      {
        path: '',
        name: 'ServiceRequests',
        component: ServiceRequestIndex,
      },
      {
        path: ':id',
        component: ServiceRequestDetails,
        name: 'ServiceRequest',
      },
    ],
  },
  {
    path: '/defectreports',
    component: EntityMain,
    children: [
      {
        path: '',
        name: 'DefectReports',
        component: DefectReportIndex,
      },
      {
        path: ':id',
        name: 'DefectReport',
        component: DefectReportDetails,
      },
    ],
  },
  {
    path: '/services',
    component: EntityMain,
    children: [
      {
        path: '',
        name: 'Services',
        component: ServiceIndex,
      },
      {
        path: ':id',
        component: ServiceDetails,
        name: 'Service',
      },
    ],
  },
  {
    path: '/partorders',
    component: EntityMain,
    children: [
      {
        path: '',
        name: 'PartOrders',
        component: PartOrderIndex,
      },
      {
        path: ':id',
        component: PartOrderDetails,
        name: 'PartOrder',
      },
    ],
  },

  {
    path: '/settings',
    component: EntityMain,
    children: [
      {
        path: '',
        name: 'settings',
        component: CorporationSettings,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
